module.exports = __webpack_public_path__ + "img/horizontal_7_4_pp12_6005.d785cd30.png";